// Base

const COMPONENT_SLUG = 'apuracao-base';

const IS_VALIDATING = window.location.hash.substr(1) === `${COMPONENT_SLUG}-debug`;

let ENV = 'prod';

export function setEnv(envParameter) {
  ENV = envParameter;
}

export { ENV };

export const LOG_LEVEL = IS_VALIDATING ? 'debug' : 'warn';

export const COMPONENT_NAME = 'Apuracao Base';
